import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { disableRestrictedAssetAccess } from '@api/assetAccess';

import { IId, IOrganizationId } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import {
	ASSET_ACCESS,
	ASSET_ACCESS_RESTRICTED,
	ASSET_ACCESS_RESTRICTED_DISABLE,
} from '@constants/queryKeys';

interface IUseMutateDisableAssetAccessReturned {
	disableAssetAccess: UseMutateFunction<any, any, IId & Partial<IOrganizationId>, any>;
	isLoadingDisableAssetAccess: boolean;
}

export const useMutateDisableAssetAccess = (): IUseMutateDisableAssetAccessReturned => {
	const queryClient = useQueryClient();

	const {
		mutate,
		isLoading,
	} = useMutation<IId & Partial<IOrganizationId>>({
		mutationKey: [ASSET_ACCESS_RESTRICTED_DISABLE],
		mutationFn: disableRestrictedAssetAccess,
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
		onSuccess: () => {
			return [
				queryClient.invalidateQueries([ASSET_ACCESS_RESTRICTED]),
				queryClient.invalidateQueries([ASSET_ACCESS]),
			];
		},
	});

	return {
		disableAssetAccess: mutate,
		isLoadingDisableAssetAccess: isLoading,
	};
};
